import React from 'react';

import Hexagon from '../../components/UI/Img/Hexagon';
import hexagonsDate from '../../components/UI/Animations/AnimationDate/sectionsHexagonsDate';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enable: false,
    };
  }

  checkScroll = (props) => {
    if ((window.pageYOffset > (document.getElementById(this.props.hexagonID).offsetTop +
    (window.innerHeight))) && (!this.state.enable)) {
      this.setState({
        enable: true,
      });
    }
  }
  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.checkScroll)
  }
  componentDidMount = () => {
    window.addEventListener('scroll', this.checkScroll)
  }
  render() {
    const dateHexagons = hexagonsDate(this.props);
    return (
      <React.Fragment>
        <Hexagon
          {...dateHexagons}
          animation_enable={dateHexagons.animation_enable ? this.state.enable : false}
        />
      </React.Fragment>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/style/actionOnScroll/index.jsx